import { WhatsappTemplateStatus } from '@/features/campaigns/v2/types/whatsappTemplates';

export type SystemModelStatus = 'approvato' | 'inRevisione' | 'nonInviato';

type WorkspaceWaTemplate = { name: string; status: WhatsappTemplateStatus };

/**
 * Match per nome esatto contro i template del workspace (tutti i WABA appiattiti);
 * con più occorrenze vince la migliore. rejected = ripresentabile → nonInviato.
 */
export const deriveWaModelStatus = (templateName: string, workspaceTemplates: WorkspaceWaTemplate[]): SystemModelStatus => {
  const matches = workspaceTemplates.filter((template) => template.name === templateName);
  if (matches.some((template) => template.status === 'approved')) return 'approvato';
  if (matches.some((template) => template.status !== 'rejected')) return 'inRevisione';
  return 'nonInviato';
};
